module.exports = __webpack_public_path__ + "static/media/Expansion of dental arches3.7154f077.png";